export const ADMIN_MENU = [
  {
    id: 'hub',
    mark: 'SA',
    titleKey: 'systemAdmin.title',
    title: 'System Admin',
    descriptionKey: 'systemAdmin.menu.hub.description',
    description: 'Overview and module launcher',
    path: '/dashboard/admin',
    hubOnly: true,
  },
  {
    id: 'companies',
    mark: 'CO',
    titleKey: 'systemAdmin.menu.companies.title',
    title: 'Companies',
    descriptionKey: 'systemAdmin.menu.companies.description',
    description: 'Manage organizations, seats, and licenses.',
    path: '/admin/companies',
  },
  {
    id: 'servers',
    mark: 'SV',
    titleKey: 'systemAdmin.menu.servers.title',
    title: 'Servers',
    descriptionKey: 'systemAdmin.menu.servers.description',
    description: 'Approve nodes, locations, and register keys.',
    path: '/admin/servers',
  },
  {
    id: 'licenses',
    mark: 'LP',
    titleKey: 'systemAdmin.menu.licenses.title',
    title: 'License plans',
    descriptionKey: 'systemAdmin.menu.licenses.description',
    description: 'Edit pricing, limits, and plan features.',
    path: '/admin/licenses',
  },
  {
    id: 'settings',
    mark: 'ST',
    titleKey: 'systemAdmin.menu.settings.title',
    title: 'Settings',
    descriptionKey: 'systemAdmin.menu.settings.description',
    description: 'Security, network, and outbound mail.',
    path: '/admin/settings',
  },
  {
    id: 'logs',
    mark: 'LG',
    titleKey: 'systemAdmin.menu.logs.title',
    title: 'Logs',
    descriptionKey: 'systemAdmin.menu.logs.description',
    description: 'Inspect system activity and failures.',
    path: '/admin/logs',
  },
  {
    id: 'downloads',
    mark: 'DL',
    titleKey: 'systemAdmin.menu.downloads.title',
    title: 'Downloads',
    descriptionKey: 'systemAdmin.menu.downloads.description',
    description: 'Publish client builds and requirements.',
    path: '/admin/downloads',
  },
  {
    id: 'tickets',
    mark: 'TK',
    titleKey: 'systemAdmin.menu.tickets.title',
    title: 'Support tickets',
    descriptionKey: 'systemAdmin.menu.tickets.description',
    description: 'Triage and reply to customer support.',
    path: '/admin/tickets',
  },
];

export const ADMIN_NAV = ADMIN_MENU.filter((item) => !item.hubOnly);
